import { render, staticRenderFns } from "./UninstallRemoveCode.vue?vue&type=template&id=39c279e0&scoped=true&"
import script from "./UninstallRemoveCode.vue?vue&type=script&lang=js&"
export * from "./UninstallRemoveCode.vue?vue&type=script&lang=js&"
import style0 from "./UninstallRemoveCode.vue?vue&type=style&index=0&id=39c279e0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c279e0",
  null
  
)

export default component.exports